import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { RootState, useGetEventByIdQuery } from '../store';
import { setSelectedEvent } from '../store/slices/events';

interface Props {
  skip?: boolean;
  slug?: boolean;
}

const useGetSelectedEvent = ({ skip = false, slug = false }: Props = {}) => {
  const dispatch = useDispatch();
  const { event_id: eventId } = useParams<{ event_id: string }>();
  const selectedEvent = useSelector((state: RootState) => state.events.selectedEvent);
  const { data: event, isLoading: eventLoading } = useGetEventByIdQuery(
    { eventId: eventId || '0', slug },
    { skip: skip || !eventId || !!selectedEvent },
  );
  useEffect(() => {
    if (event && !selectedEvent) {
      dispatch(setSelectedEvent(event));
    }
  }, [event, selectedEvent, dispatch]);

  if (skip) {
    return { event: null, eventLoading: false };
  }
  return { event: event || selectedEvent, eventLoading };
};

export default useGetSelectedEvent;
